import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { $cardStore } from '@lib/store';
import { cn, PaletteUtils } from '@shared/utils';
import { Button, Modal, Text } from '@shared/widgets';

interface ActivateModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ActivateModal = (props: ActivateModalProps) => {
  const cardStore = useUnit($cardStore.store);

  const { t } = useTranslation('card');

  const activateHandler = async () => {
    await $cardStore.events.activate(cardStore.data!.cardId);
    props.onClose();
  };

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} loading={cardStore.actionLoading} title={t('sidebar.modals.activate.title')} width='332px'>
      <div className={cn(PaletteUtils.isVcfcPalette && 'my-6')}>
        {PaletteUtils.isVcfcPalette ? (
          <Text weight='medium' className='text-center'>
            {t('sidebar.modals.activate.descriptionVcfc')}
          </Text>
        ) : (
          <Text
            weight='medium'
            dangerouslySetInnerHTML={{
              __html: t('sidebar.modals.activate.description', {
                cardHolder: cardStore.data?.cardHolder || '',
                lastDigits: cardStore.data?.cardNumber?.slice(-4) || '',
              }),
            }}
          />
        )}
        <div className='mt-6'>
          <div className='-my-3 flex justify-between'>
            <div className='w-3/6 flex-none px-3'>
              <Button fullWidth color='outlined' onClick={props.onClose}>
                {t('buttons.close', { ns: 'common' })}
              </Button>
            </div>
            <div className='w-3/6 flex-none px-3'>
              <Button fullWidth color='primary' onClick={activateHandler}>
                {t('sidebar.modals.activate.buttons.activate')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
